import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron-thin-down",
  "use": "chevron-thin-down-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"chevron-thin-down\"><title>chevron-thin-down</title><path d=\"M26.267 6.725c.45-.443 1.172-.443 1.619 0s.448 1.159 0 1.602L14.809 21.275a1.152 1.152 0 0 1-1.619 0L.113 8.327a1.126 1.126 0 0 1 0-1.602 1.152 1.152 0 0 1 1.619 0L14 18.533 26.266 6.725z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol